import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User, UserAnketa } from '../../models';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http: HttpClient
  ) { }

  public getCurrentUser() {
    return this.http.get<{
      code: string;
      data: User
    }>(`${environment.host}/user/profile`);
  }

  public search(search: string) {
    let queries = '';
    if (search) {
      queries = '?search=' + search;
    }
    
    return this.http.get<{
      code: string;
      data: Array<User>
    }>(`${environment.host}/user/search/${queries}`);
  }

  public addAnketa(data: UserAnketa): Observable<any> {
    data.phone = data.phone.replaceAll(' ', '').replaceAll('-', '').replace('(', '').replace(')', '').replace('+', '');
    return this.http.post(environment.host + '/user/anketa/', data);
  }
}
